import { CheckoutPaymentMethod } from "../../PaymentMethod.ts";
import { PaymentMethodStepConfig } from "../PaymentMethodStepInterface.ts";
import { CardOneTimePaymentStep } from "./CardOneTimePaymentStep.tsx";
import {
  FaCreditCard,
  FaPaypal,
  FaApplePay,
  FaGooglePay,
} from "react-icons/fa6";
import { CardInstallmentsPaymentStep } from "./CardInstallmentsPaymentStep.tsx";

const supportedCardPaymentIcons = [
  <FaCreditCard className="h-6 w-6 text-gray-400" />,
  <FaPaypal className="h-6 w-6 text-gray-400" />,
  <FaApplePay className="h-6 w-6 text-gray-400" />,
  <FaGooglePay className="h-6 w-6 text-gray-400" />,
];

export const CardOneTimePaymentStepConfig: PaymentMethodStepConfig = {
  method: CheckoutPaymentMethod.StripeOneTime,
  StepComponent: CardOneTimePaymentStep,
  isAvailableForItem: (product) => !!product.stripeConfig?.oneTimeEnabled,
  icons: supportedCardPaymentIcons,
};

export const CardInstallmentPaymentStepConfig: PaymentMethodStepConfig = {
  method: CheckoutPaymentMethod.StripeInstallments,
  StepComponent: CardInstallmentsPaymentStep,
  isAvailableForItem: (product) => !!product.stripeConfig?.installmentsEnabled,
  icons: supportedCardPaymentIcons,
};
